import { AttentionKind, AttentionLine } from "../attentionLines";

interface iAttentionStripProps {
    lines: AttentionLine[];
}

// Failing and Stale keep the same red/amber the table's own health dot uses
// for those states. Behind and Stalled are warnings, not the healthy green
// `.mp-dot-ok` — every line on this strip exists because something is wrong,
// so a green marker on any of them would read backwards. They get their own
// `.mp-dot-warn` rather than reusing `.mp-dot-stale`: same amber, but that
// class's name would misname the kind it marks.
const KIND_DOT: Record<AttentionKind, string> = {
    failing: "mp-dot mp-dot-fail",
    stale: "mp-dot mp-dot-stale",
    behind: "mp-dot mp-dot-warn",
    stalled: "mp-dot mp-dot-warn",
};

/**
 * One line per fault, in plain language.
 *
 * Renders nothing when there is nothing to say, so it costs no vertical space
 * on a good day. This is what guarantees a fault is seen: the table keeps the
 * server's worst-first order, which knows nothing about our client-derived
 * "behind", so a rising-backlog tenant can sit mid-table.
 */
function AttentionStrip({ lines }: iAttentionStripProps) {
    if (lines.length === 0) {
        return null;
    }

    return (
        <div className="mp-attention">
            <div className="mp-attention-heading">Needs attention</div>
            {lines.map((line, index) => (
                <div
                    key={`${line.tenantKey}-${line.kind}-${index}`}
                    className="mp-attention-line"
                >
                    <span className={KIND_DOT[line.kind]} />
                    <span className="mp-tenant-name">{line.name}</span>
                    {` — ${line.message}`}
                </div>
            ))}
        </div>
    );
}

export default AttentionStrip;
